import { render } from "./index.vue?vue&type=template&id=2089864c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./index.vue?vue&type=style&index=0&id=2089864c&lang=scss&module=true"
cssModules["$style"] = style0
import "./index.vue?vue&type=style&index=1&id=2089864c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules],['__scopeId',"data-v-2089864c"]])

export default __exports__